import type { CheckoutTransportInfo } from '@/scopes/checkout/domain/types'

export function getAirlinesNames(transportInfo?: CheckoutTransportInfo | null): string[] {
  if (!transportInfo)
    return []

  if (transportInfo.type !== 'flight')
    return []

  return transportInfo.details.map(({ name }) => name)
}
